/* FBP catalogue search. Public product data only; no network requests or DOM writes. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FBPSearchEngine = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function text(value) { return value == null ? '' : String(value).trim(); }
  function normalize(value) {
    return text(value).slice(0, 20000).toLowerCase().normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/ł/g, 'l')
      .replace(/ß/g, 'ss').replace(/æ/g, 'ae').replace(/œ/g, 'oe')
      .replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
  }
  function key(value) { return normalize(value).replace(/ /g, '-'); }
  function words(value) { return normalize(value).split(' ').filter(Boolean); }
  function unique(values) { return Array.from(new Set(values.filter(Boolean))); }
  function includesPhrase(haystack, needle) {
    return Boolean(needle) && (' ' + haystack + ' ').includes(' ' + needle + ' ');
  }
  function values(value) {
    if (Array.isArray(value)) return value.flatMap(values);
    var s = text(value);
    if (!s) return [];
    if (s.charAt(0) === '[') {
      try { var parsed = JSON.parse(s); if (Array.isArray(parsed)) return parsed.flatMap(values); } catch (_) { /* plain text */ }
    }
    return s.split(/[,;|]+/).map(text).filter(Boolean);
  }

  // Identity aliases established in monthly-newsletter-job.js, including Torben's Tan confirmation.
  var ARTIST_ALIASES = {
    ram: 'Ram the Dragon', ramarts: 'Ram the Dragon', 'ram the dragon': 'Ram the Dragon', 'ram dragon': 'Ram the Dragon',
    // Torben confirmed these are one artist on 12 September 2026.
    'sofia ram': 'Ram the Dragon', sofiaram: 'Ram the Dragon',
    fensu: 'Fensu', 'fensu san': 'Fensu', soapaint: 'Soapaint', ruhisu: 'Ruhisu',
    dreamweaver: 'Dreamweaver', 'zanger danger': 'Zanger Danger', 'saint cocoa': 'Saint Cocoa',
    saintcocoa: 'Saint Cocoa', discordthege: 'DiscordtheGE', 'max fauler lifejoyart': 'Max Fauler',
    'max fauler': 'Max Fauler', 'insane nicky': 'Insane Nicky', 'quoc anh phung': 'Quốc Anh Phùng',
    freakat17: 'Freakat17', amicuru: 'Amicuru', 'amicuru art': 'Amicuru', basilisk: 'Basilisk',
    'yulia gruzdeva': 'Yulia Gruzdeva', 'julia gruzdeva': 'Yulia Gruzdeva', arca: 'Arca',
    echo: 'Echo', tan: 'Taneysha', taneysha: 'Taneysha'
  };

  var SPECIES = [
    ['Snow leopard', 'snow leopard|snow leopards', 'Leopard'],
    ['Red panda', 'red panda|red pandas', ''],
    ['Cat', 'cat|cats|kitty|kitties|kitten|kittens|catgirl|catgirls|neko', 'Feline'],
    ['Tiger', 'tiger|tigers|tigress', 'Feline'], ['Lion', 'lion|lions|lioness', 'Feline'],
    ['Leopard', 'leopard|leopards', 'Feline'], ['Cheetah', 'cheetah|cheetahs', 'Feline'],
    ['Lynx', 'lynx|lynxes', 'Feline'], ['Panther', 'panther|panthers', 'Feline'],
    ['Feline', 'feline|felines|big cat|big cats', ''],
    ['Husky', 'husky|huskies', 'Dog'], ['Dog', 'dog|dogs|puppy|puppies|canine dog', 'Canine'],
    ['Wolf', 'wolf|wolves', 'Canine'], ['Fox', 'fox|foxes|fennec|vulpine', 'Canine'],
    ['Coyote', 'coyote|coyotes', 'Canine'], ['Canine', 'canine|canines', ''],
    ['Dragon', 'dragon|dragons|drake|drakes', ''], ['Bat', 'bat|bats', ''],
    ['Shark', 'shark|sharks', 'Sea creature'], ['Otter', 'otter|otters', ''],
    ['Dolphin', 'dolphin|dolphins', 'Sea creature'], ['Orca', 'orca|orcas|killer whale', 'Sea creature'],
    ['Sea creature', 'sea creature|sea creatures|sea life|marine', ''],
    ['Phoenix', 'phoenix|phoenixes', 'Bird'], ['Bird', 'bird|birds|avian|avians', ''],
    ['Gryphon', 'gryphon|gryphons|griffin|griffins|griffon|griffons', ''],
    ['Horse', 'horse|horses|stallion|mare', 'Equine'], ['Pony', 'pony|ponies', 'Equine'],
    ['Zebra', 'zebra|zebras', 'Equine'], ['Unicorn', 'unicorn|unicorns', 'Equine'],
    ['Equine', 'equine|equines', ''], ['Rabbit', 'rabbit|rabbits|bunny|bunnies|hare|hares', ''],
    ['Raccoon', 'raccoon|raccoons|racoon|racoons', ''], ['Bear', 'bear|bears', ''],
    ['Panda', 'panda|pandas', ''], ['Deer', 'deer|doe|stag', ''],
    ['Cow', 'cow|cows|cattle|bull|bulls|bovine', ''], ['Hyena', 'hyena|hyenas|hyaena', ''],
    ['Lemur', 'lemur|lemurs', ''], ['Mouse', 'mouse|mice', 'Rodent'], ['Rat', 'rat|rats', 'Rodent'],
    ['Squirrel', 'squirrel|squirrels', 'Rodent'], ['Rodent', 'rodent|rodents', ''],
    ['Raptor', 'raptor|raptors|velociraptor', 'Dinosaur'], ['Dinosaur', 'dinosaur|dinosaurs|dino', ''],
    ['Protogen', 'protogen|protogens', ''], ['Avali', 'avali', ''], ['Sergal', 'sergal|sergals', '']
  ];
  var speciesByLabel = new Map(SPECIES.map(function (s) { return [s[0], s]; }));
  var collectionSpecies = {
    'feline-body-pillow': 'Feline', 'wolf-body-pillow': 'Wolf', 'dragon-body-pillows': 'Dragon',
    'fox-body-pillow': 'Fox', 'sea-creatures-body-pillow': 'Sea creature', 'bird-body-pillow': 'Bird',
    'raccoon-body-pillow': 'Raccoon', 'equines-body-pillow': 'Equine'
  };
  // Live Admin descriptions verified 2026-09-12: exact named-character sentences in the original
  // dakimakura and each head-cover's "Design:" sentence establish these species. Titles/handles
  // alone omit them. Keep this six-item compatibility table guarded by the observed title; a real
  // custom.species value always wins. No whole description or cross-selling boilerplate is indexed.
  var verifiedSpecies = {
    'starry-dakimakura': ['Starry', 'Squirrel'],
    'starry-female-head-pillow-cover': ['Starry Female Head Pillow Cover', 'Squirrel'],
    'elevit-dakimakura': ['Elevit', 'Mouse'],
    'elevit-female-head-pillow-cover': ['Elevit Female Head Pillow Cover', 'Mouse'],
    'equa-dakimakura': ['Equa', 'Red panda'],
    'equa-female-head-pillow-cover': ['Equa Female Head Pillow Cover', 'Red panda']
  };
  var TYPE_ALIASES = {
    'Dakimakura': ['dakimakura', 'dakimakuras', 'daki', 'dakis', 'body pillow', 'body pillows', 'bodypillow', 'bodypillows', 'hug pillow', 'long pillow'],
    'Head pillow cover': ['head pillow', 'head pillows', 'head pillow cover', 'bed pillow', 'bed pillows', 'square pillow', 'cushion', 'cushions', 'throw pillow'],
    'Blanket': ['blanket', 'blankets', 'throw blanket'], 'Hoodie': ['hoodie', 'hoodies', 'sweatshirt', 'sweatshirts'],
    'Pillow insert': ['pillow insert', 'pillow inserts', 'inner pillow', 'inner pillows', 'pillow inner', 'pillow filling'],
    'Coaster': ['coaster', 'coasters'], 'Magnet': ['magnet', 'magnets'],
    'Keychain': ['keychain', 'keychains', 'keyring', 'keyrings'], 'Bottle opener': ['bottle opener', 'bottle openers'],
    'Print': ['print', 'prints', 'poster', 'posters'], 'Mousepad': ['mousepad', 'mousepads', 'mouse pad', 'desk mat'],
    'T-shirt': ['t shirt', 't shirts', 'tshirt', 'tshirts', 'tee shirt']
  };
  var collectionTypes = {
    'body-pillow-covers-furry-dakimakura': 'Dakimakura', 'dakimakura-design-heads': 'Head pillow cover',
    'standalone-head-pillow-covers': 'Head pillow cover', 'pillow-covers': 'Head pillow cover',
    blankets: 'Blanket', hoodies: 'Hoodie'
  };
  var aliasesToType = new Map();
  Object.keys(TYPE_ALIASES).forEach(function (label) {
    TYPE_ALIASES[label].concat([label]).forEach(function (a) { aliasesToType.set(normalize(a), label); });
  });
  function collectionHandles(p) {
    return (Array.isArray(p.collections) ? p.collections : []).map(function (c) {
      return typeof c === 'string' ? c : text(c && c.handle);
    });
  }
  function getTypes(p) {
    var title = normalize(p.title), handles = collectionHandles(p);
    var explicit = aliasesToType.get(normalize(p.productType));
    if (explicit) return [explicit];
    // Head-cover tags are copied from full dakimakura designs: their dedicated title/collection wins.
    if (/\b(head|bed|square|throw) pillow\b/.test(title) || /\bcushion\b/.test(title) ||
        handles.some(function (h) { return collectionTypes[h] === 'Head pillow cover'; })) return ['Head pillow cover'];
    if (/\b(blanket|blankets)\b/.test(title) || handles.includes('blankets')) return ['Blanket'];
    if (/\b(hoodie|hoodies|sweatshirt)\b/.test(title) || handles.includes('hoodies')) return ['Hoodie'];
    if (/\b(inner pillow|pillow insert|pillow filling)\b/.test(title)) return ['Pillow insert'];
    if (handles.includes('body-pillow-covers-furry-dakimakura')) return ['Dakimakura'];
    var other = Object.keys(TYPE_ALIASES).filter(function (label) {
      return label !== 'Print' && TYPE_ALIASES[label].some(function (a) { return includesPhrase(title, normalize(a)); });
    });
    if (other.length) return [other[0]];
    if (/\b(dakimakura|body pillow)\b/.test(normalize(p.handle)) ||
        (p.tags || []).some(function (t) { return /^(dakimakura|daki|furry dakimakura)$/i.test(text(t)); })) return ['Dakimakura'];
    if (/\b(print|poster)s?\b/.test(title)) return ['Print'];
    return [];
  }
  function canonicalArtist(raw) {
    var value = text(raw).replace(/^art(?:work)?\s+by\s+/i, '').trim();
    if (!value || /^https?:|^www\./i.test(value) || aliasesToType.has(normalize(value))) return '';
    return ARTIST_ALIASES[normalize(value)] || value;
  }
  function getArtists(p) {
    var raw = values(p.artist);
    if (!raw.length && !aliasesToType.has(normalize(p.productType))) raw = values(p.productType);
    return unique(raw.flatMap(function (v) { return v.split(/\s+(?:and|&)\s+|\s*&\s*/i); }).map(canonicalArtist));
  }
  function scanSpecies(input) {
    var source = normalize(input), found = [];
    // Consume specific phrases first: a red panda must not become a giant panda.
    SPECIES.forEach(function (s) {
      var matched = s[1].split('|').find(function (a) { return includesPhrase(source, a); });
      if (matched) {
        found.push(s[0]);
        if (s[0] === 'Red panda') source = source.replace(/\bred pandas?\b/g, ' ');
      }
    });
    return unique(found);
  }
  function familySpecies(found) {
    var result = found.slice();
    for (var i = 0; i < result.length; i++) {
      var row = speciesByLabel.get(result[i]);
      if (row && row[2] && !result.includes(row[2])) result.push(row[2]);
    }
    return result;
  }
  function getSpecies(p) {
    var explicit = values(p.species);
    if (explicit.length) return familySpecies(unique(explicit.flatMap(function (s) { return scanSpecies(s).length ? scanSpecies(s) : [s]; })));
    var verified = verifiedSpecies[p.handle];
    if (verified && text(p.title) === verified[0]) return familySpecies([verified[1]]);
    var title = text(p.title).split(/\s+by\s+/i)[0];
    var found = scanSpecies(title);
    // A current descriptive title outranks old handles (Clawson is a lynx, though its handle says dragon).
    if (!found.length) found = scanSpecies(p.handle);
    if (!found.length) found = scanSpecies(text(p.imageAlt).split(/\s+by\s+/i)[0]);
    if (!found.length) found = unique((p.tags || []).flatMap(function (t) {
      var exact = normalize(t);
      return SPECIES.filter(function (s) { return s[1].split('|').includes(exact); }).map(function (s) { return s[0]; });
    }));
    if (!found.length) found = unique(collectionHandles(p).map(function (h) { return collectionSpecies[h] || ''; }));
    return familySpecies(found);
  }
  function getCharacters(p) {
    var explicit = values(p.character);
    if (explicit.length) return unique(explicit);
    var title = text(p.title).replace(/\s+by\s+.+$/i, '').replace(/\s+(?:male\/female|male|female|femboy)?\s*(?:head|bed) pillow cover.*$/i, '').trim();
    var the = title.match(/^(.+?)\s+the\s+/i);
    if (the && words(the[1]).length <= 4 && !scanSpecies(the[1]).length) return [the[1]];
    var short = title.replace(/\s+(?:femboy|male|female)\b.*$/i, '').replace(/\s+(?:dakimakura|body pillow(?: cover)?)\b.*$/i, '').trim();
    if (short && words(short).length <= 3 && !scanSpecies(short).length &&
        !/\b(furry|art|cover|pillow|blanket|hoodie|anime|blue|brown|pink|purple|white|black|red|green|space|print|girl|boy)\b/i.test(short)) return [short];
    return [];
  }
  function artistSearchTerms(artists) {
    var terms = artists.slice();
    artists.forEach(function (artist) {
      Object.keys(ARTIST_ALIASES).forEach(function (alias) { if (ARTIST_ALIASES[alias] === artist) terms.push(alias); });
      terms.push(normalize(artist).replace(/ /g, ''));
    });
    return terms;
  }
  function speciesSearchTerms(species) {
    return species.flatMap(function (label) {
      var row = speciesByLabel.get(label);
      var aliases = row ? row[1].split('|') : [label];
      // Customers use cat for the wider feline family as well as domestic cats.
      return label === 'Feline' ? aliases.concat(['cat', 'cats']) : aliases;
    });
  }
  function createIndex(rawProducts) {
    var products = [], seen = new Set();
    (Array.isArray(rawProducts) ? rawProducts : []).forEach(function (raw, ordinal) {
      if (!raw || typeof raw !== 'object' || !text(raw.handle) || !text(raw.title)) return;
      // Visibility is enforced by the Liquid source. These checks defend cached/test input too.
      if (raw.status && raw.status !== 'ACTIVE' || raw.hidden === true || raw.hidden === 1 || raw.hidden === '1' || raw.private === true) return;
      if ((Array.isArray(raw.tags) ? raw.tags : []).some(function (t) { return /^(private|unlisted|hidden|private-listing|custom-order-private)$/i.test(text(t)); })) return;
      if (seen.has(raw.handle)) return;
      seen.add(raw.handle);
      var p = Object.assign({}, raw);
      p.tags = Array.isArray(raw.tags) ? raw.tags.slice() : [];
      p.artists = getArtists(p); p.species = getSpecies(p); p.characters = getCharacters(p); p.types = getTypes(p);
      var fields = [
        [normalize(p.characters.join(' ')), 12], [normalize(p.title), 10],
        [normalize(artistSearchTerms(p.artists).join(' ')), 9],
        [normalize(speciesSearchTerms(p.species).join(' ')), 8],
        [normalize(p.types.flatMap(function (t) { return (TYPE_ALIASES[t] || []).concat([t]); }).join(' ')), 8],
        [normalize(p.handle), 5], [normalize(p.keywords), 4], [normalize(p.tags.join(' ')), 2]
      ];
      var weightByToken = new Map();
      fields.forEach(function (f) { words(f[0]).forEach(function (w) { weightByToken.set(w, Math.max(weightByToken.get(w) || 0, f[1])); }); });
      Object.defineProperty(p, '_search', { value: { ordinal: ordinal, fields: fields, tokens: Array.from(weightByToken.keys()), weights: weightByToken, title: normalize(p.title), characters: p.characters.map(normalize), artists: p.artists.map(normalize) } });
      products.push(p);
    });
    var facets = {};
    [['artist', 'artists'], ['species', 'species'], ['character', 'characters'], ['type', 'types']].forEach(function (pair) {
      var entries = new Map();
      products.forEach(function (p) {
        unique(p[pair[1]].map(key)).forEach(function (value) {
          if (!value) return;
          var label = p[pair[1]].find(function (s) { return key(s) === value; });
          var previous = entries.get(value);
          if (previous) previous.count++;
          else entries.set(value, { value: value, label: label, count: 1, searchTerms: pair[0] === 'artist' ? artistSearchTerms([label]) : [label] });
        });
      });
      facets[pair[0]] = Array.from(entries.values()).sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }) || a.value.localeCompare(b.value); });
    });
    var index = { products: products, facets: facets };
    var artistLabels = facets.artist.map(function (f) { return f.label; });
    var artistPhrases = unique(artistSearchTerms(artistLabels).map(normalize)).sort(function (a, b) { return b.length - a.length; });
    var exactArtists = new Map();
    artistLabels.forEach(function (label) {
      artistSearchTerms([label]).forEach(function (alias) {
        var normalized = normalize(alias);
        // Ambiguous names must remain a broad search instead of silently choosing one artist.
        exactArtists.set(normalized, exactArtists.has(normalized) && exactArtists.get(normalized) !== label ? null : label);
      });
    });
    Object.defineProperty(index, '_search', { value: { artistPhrases: artistPhrases, exactArtists: exactArtists } });
    return index;
  }

  var STOP_WORDS = new Set(['a', 'an', 'the', 'by', 'and', 'of', 'for', 'with', 'artist', 'art']);
  var queryAliases = new Map();
  SPECIES.forEach(function (s) { s[1].split('|').forEach(function (a) { if (!a.includes(' ')) queryAliases.set(a, s[1].split('|')[0]); }); });
  Object.keys(TYPE_ALIASES).forEach(function (label) {
    TYPE_ALIASES[label].forEach(function (a) { if (!a.includes(' ')) queryAliases.set(a, TYPE_ALIASES[label][0].split(' ')[0]); });
  });
  function queryTerms(query) {
    return unique(words(query).filter(function (w) { return !STOP_WORDS.has(w); }).map(function (w) { return queryAliases.get(w) || w; }));
  }
  function queryTypeIntent(query) {
    var q = normalize(query);
    var found = Object.keys(TYPE_ALIASES).filter(function (label) {
      if (label === 'Print') return false; // "dragon print hoodie" describes the artwork.
      return TYPE_ALIASES[label].some(function (a) { return includesPhrase(q, a); });
    });
    // Explicit cover/blanket language overrides the broad body-pillow tokens copied into tags.
    if (found.includes('Head pillow cover')) return 'Head pillow cover';
    if (found.includes('Pillow insert')) return 'Pillow insert';
    return found.length === 1 ? found[0] : '';
  }
  function classificationQuery(index, query) {
    // Artist names are identities, not species (Flash_lioness draws much more than lions).
    var artistPhrases = index && index._search ? index._search.artistPhrases : [];
    if (words(query).length > 1 && artistPhrases.some(function (a) { return a.startsWith(query); })) return '';
    var result = ' ' + query + ' ';
    artistPhrases.forEach(function (artist) { result = result.split(' ' + artist + ' ').join(' '); });
    return normalize(result);
  }
  function querySpeciesIntent(query) {
    var found = scanSpecies(query);
    return found.filter(function (s) { return s !== 'Cat'; }).concat(found.includes('Cat') ? ['Feline'] : []);
  }
  function matchesFilters(p, filters) {
    return [['artist', 'artists'], ['species', 'species'], ['character', 'characters'], ['type', 'types']].every(function (pair) {
      var wanted = text(filters[pair[0]]);
      if (wanted && pair[0] === 'artist') wanted = canonicalArtist(wanted);
      return !wanted || p[pair[1]].some(function (v) { return key(v) === key(wanted); });
    });
  }
  function near(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return false;
    if (a === b) return true;
    // Bounded Damerau-Levenshtein supports common transposed keystrokes without broad fuzzy matches.
    var prevprev = null, prev = Array.from({ length: b.length + 1 }, function (_, i) { return i; });
    for (var i = 1; i <= a.length; i++) {
      var row = [i], rowMin = i;
      for (var j = 1; j <= b.length; j++) {
        row[j] = Math.min(row[j - 1] + 1, prev[j] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (prevprev && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) row[j] = Math.min(row[j], prevprev[j - 2] + 1);
        rowMin = Math.min(rowMin, row[j]);
      }
      if (rowMin > max) return false;
      prevprev = prev; prev = row;
    }
    return prev[b.length] <= max;
  }
  function score(p, terms, query, fuzzy) {
    if (!terms.length) return 0;
    var data = p._search, total = 0;
    for (var i = 0; i < terms.length; i++) {
      var term = terms[i], best = data.weights.get(term) || 0;
      if (!best) {
        for (var j = 0; j < data.tokens.length; j++) {
          var candidate = data.tokens[j];
          if (term.length >= 2 && candidate.startsWith(term)) best = Math.max(best, data.weights.get(candidate) * 0.7);
          else if (fuzzy && term.length >= 4 && candidate.length >= 4 && near(term, candidate, term.length >= 8 ? 2 : 1)) best = Math.max(best, data.weights.get(candidate) * 0.4);
        }
      }
      if (!best) return -1;
      total += best;
    }
    if (data.characters.includes(query)) total += 150;
    if (data.title === query) total += 130;
    if (data.artists.includes(query)) total += 110;
    if (includesPhrase(data.title, query)) total += 35;
    if (data.title.startsWith(query)) total += 20;
    return total;
  }
  function search(index, rawQuery, filters, limit) {
    filters = filters && typeof filters === 'object' ? filters : {};
    var query = normalize(text(rawQuery).slice(0, 300)), terms = queryTerms(query).slice(0, 24);
    var classification = classificationQuery(index, query);
    var typeIntent = queryTypeIntent(classification), speciesIntent = querySpeciesIntent(classification);
    var artistIntent = index && index._search && index._search.exactArtists.get(query);
    // An exact character identity takes precedence over a coincidentally identical artist name.
    if (artistIntent && (index.facets.character || []).some(function (f) { return normalize(f.label) === query; })) artistIntent = null;
    var candidates = ((index && index.products) || []).filter(function (p) {
      return matchesFilters(p, filters) && (!artistIntent || p.artists.includes(artistIntent)) && (!typeIntent || p.types.includes(typeIntent)) &&
        speciesIntent.every(function (s) { return p.species.includes(s); });
    });
    function ranked(fuzzy) {
      return candidates.map(function (p) { return { item: p, score: score(p, terms, query, fuzzy) }; })
        .filter(function (r) { return r.score >= 0; }).sort(function (a, b) {
          return b.score - a.score || (a.item.types.includes('Dakimakura') ? 0 : 1) - (b.item.types.includes('Dakimakura') ? 0 : 1) ||
            a.item.title.localeCompare(b.item.title, undefined, { sensitivity: 'base' }) || a.item.handle.localeCompare(b.item.handle);
        });
    }
    var results = ranked(false), corrected = false;
    if (!results.length && terms.length && terms.some(function (t) { return t.length >= 4; })) {
      results = ranked(true); corrected = results.length > 0;
    }
    var n = limit === undefined ? 24 : Number(limit);
    n = Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 24;
    return { total: results.length, items: results.slice(0, n).map(function (r) { return r.item; }), corrected: corrected };
  }
  return Object.freeze({ createIndex: createIndex, search: search, normalize: normalize, facetValue: key, version: '2026-09-12.1' });
});
